import WebhooksList from '@/features/webhooks/WebhookList'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/webhooks')({
  component: WebhooksList,
})
